import {
    AUTH_REQUEST,
    AUTH_ERROR,
    AUTH_SUCCESS,
    AUTH_LOGOUT
} from "../actions/auth";
import axios from "axios";

const state = {
    token: localStorage.getItem("users-token") || "",
    role: localStorage.getItem("users-role") || "",
    tokenExpire: localStorage.getItem("expire-on") || "",
    status: "",
    hasLoadedOnce: false
};

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status
};

const actions = {
    [AUTH_REQUEST]: ({commit}, user) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            axios({url: process.env.VUE_APP_CRAWLING_URL + "/auth/login", data: user, method: 'POST'})
                .then(resp => {
                    localStorage.setItem("users-role", resp.data.role[0]); // store users role
                    let time = new Date();
                    let expireOn = time.setSeconds(time.getSeconds() + resp.data["expires_in"]);
                    localStorage.setItem('expire-on', expireOn.toString());
                    const token = "Bearer " + resp.data["access_token"]
                    localStorage.setItem('users-token', token); // store the token in localstorage
                    commit(AUTH_SUCCESS, token);
                    axios.defaults.headers.common['Authorization'] = token;
                    resolve(resp);
                })
                .catch(err => {
                    commit(AUTH_ERROR, err);
                    localStorage.removeItem('users-token') // if the request fails, remove any possible users token if possible
                    reject(err);
                })
        });
    },
    [AUTH_LOGOUT]: ({commit}) => {
        return new Promise(resolve => {
            commit(AUTH_LOGOUT);
            localStorage.removeItem("users-token");
            resolve();
        });
    }
};

const mutations = {
    [AUTH_REQUEST]: state => {
        state.status = "loading";
    },
    [AUTH_SUCCESS]: (state, resp) => {
        state.status = "success";
        state.token = resp.token;
        state.hasLoadedOnce = true;
    },
    [AUTH_ERROR]: state => {
        state.status = "error";
        state.hasLoadedOnce = true;
    },
    [AUTH_LOGOUT]: state => {
        state.token = "";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};